import React from 'react';
import { CTAButton } from './CTAButton';
export function MidPageCTA() {
  return <section className="py-8 px-4 bg-white" data-id="element-86">
      <div className="max-w-3xl mx-auto text-center" data-id="element-87">
        <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4" data-id="element-88">
          Accedé ahora al pack completo listo para usar durante todo el año
        </h2>
        <CTAButton href="#compra" className="w-full md:w-auto" data-id="element-89">
          Obtener acceso inmediato al material
        </CTAButton>
      </div>
    </section>;
}